import { render, staticRenderFns } from "./district-admin-details.vue?vue&type=template&id=57a34015&"
import script from "./district-admin-details.vue?vue&type=script&lang=js&"
export * from "./district-admin-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports